import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";
import {
  PAGE_ROUTE_MEMBERSHIP_SUBSCRIPTIONS,
  BRAND_COLOR,
  BRAND_HOVER,
  useKivunovaTranslation
} from "@kivunova/kivufrontendcommon";
import CreditCardIcon from "@mui/icons-material/CreditCard";

/**
 * Component that displays subscription information and provides
 * a link to navigate to the full subscriptions management page.
 */
const SubscriptionLink: React.FC = () => {
  const { t } = useKivunovaTranslation();
  const navigate = useNavigate();

  const handleViewSubscriptions = () => {
    navigate(`/${PAGE_ROUTE_MEMBERSHIP_SUBSCRIPTIONS}`);
  };

  return (
    <Box
      data-testid="company-subscriptions"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 6,
        px: 3,
        textAlign: "center"
      }}
    >
      <CreditCardIcon
        sx={{ fontSize: 64, color: BRAND_COLOR, mb: 2, opacity: 0.8 }}
      />
      <Typography variant="h6" gutterBottom>
        {t("company-subscriptions-cta-title", "Manage Your Subscriptions")}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mb: 3, maxWidth: 400 }}
      >
        {t(
          "company-subscriptions-cta-description",
          "View and manage your subscription plans, billing history, and payment details in the subscriptions portal."
        )}
      </Typography>
      <Button
        variant="contained"
        size="large"
        onClick={handleViewSubscriptions}
        startIcon={<CreditCardIcon />}
        data-testid="company-subscriptions-view-button"
        sx={{
          backgroundColor: BRAND_COLOR,
          textTransform: "none",
          "&:hover": {
            backgroundColor: BRAND_HOVER
          }
        }}
      >
        {t("company-subscriptions-cta-button", "View subscriptions")}
      </Button>
    </Box>
  );
};

export default SubscriptionLink;
